import yup from 'services/yup';
import i18n from 'i18next';

export const schema = yup.object().shape({
  first_name: yup.string().trim().required(i18n.t('shared.dialogs.requiredFirstName')),
  last_name: yup.string().trim().required(i18n.t('shared.dialogs.requiredLastName')),
  phone_number: yup
    .string()
    .trim()
    .typeError(i18n.t('shared.dialogs.requiredPhone'))
    .required(i18n.t('shared.dialogs.requiredPhone')),
});
